// Shared constants and pure helpers for the jobs feature, used by both the
// per-operator AssignedJobsSection and the admin all-jobs table.

export const JOB_STAGES = [
    { key: 'qa_rejected', label: 'QA rejected', short: 'QA rejected', color: '#e05c5c' },
    { key: 'customer_accepted', label: 'Customer accepted', short: 'Customer accepted', color: '#4caf7d' },
    { key: 'customer_rejected', label: 'Customer rejected', short: 'Customer rejected', color: '#d4708a' },
    { key: 'qc', label: 'QC accepted', short: 'QC accepted', color: '#d4a84b' },
    { key: 'initial', label: 'Initial accepted', short: 'Initial accepted', color: '#5a9fd4' },
    { key: 'rejected', label: 'Initial rejected', short: 'Initial rejected', color: '#e05c5c' },
];
export const stageByKey = (key) => JOB_STAGES.find((s) => s.key === key);

// Dot color for each timeline step key (distinct from JOB_STAGES' own
// per-stage color, since a step key like 'initial' or 'qc' always means the
// same thing regardless of which stage the episode ultimately reached).
export const TIMELINE_DOT_COLOR = {
    qa_rejected: '#e05c5c',
    initial: '#5a9fd4',
    qc: '#d4a84b',
    customer_accepted: '#4caf7d',
    customer_rejected: '#d4708a',
    rejected: '#e05c5c',
};

export const JOB_NAME_MAX_LEN = 80;
export const jobLabel = (job) => job.job_name || `JOB-${job.job_id}`;

export const fmtHrs = (n) => Number(n || 0).toFixed(3).replace(/0$/, '');
export const fmtUSD = (n) => '$' + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function daysUntil(dateStr, todayStr) {
    if (!dateStr) return null;
    const today = todayStr ? new Date(todayStr + 'T00:00:00Z') : new Date();
    return Math.round((Date.parse(dateStr + 'T00:00:00Z') - today.setUTCHours(0, 0, 0, 0)) / 86400000);
}

export function jobHoursTarget(job) {
    return (job.tasks || []).reduce((a, t) => a + (Number(t.assigned_hours) || 0), 0);
}

export function taskUrl(taskId) {
    return `/data/upload?job=true#${taskId}`;
}

export function robotUrl(machineId) {
    return `/data/fleet#${machineId}`;
}

export function paymentState(job) {
    const earned = Number(job.amount_earned_total || 0);
    const paid = Number(job.amount_paid_total || 0);
    // An operator is paid exactly once per job, so paid > 0 means settled —
    // there is no partial-payment state to distinguish anymore.
    if (earned === 0 && paid === 0) return { key: 'none', label: 'Nothing earned yet', color: '#555' };
    if (paid > 0) {
        const paidDate = job.last_payment_at ? job.last_payment_at.slice(0, 10) : '';
        return { key: 'paid', label: `Paid ${paidDate}`.trim(), color: '#4caf7d' };
    }
    // Until the order clears customer approval (ready_for_invoice/complete),
    // the earned amount hasn't really been accepted yet — showing it as
    // "not paid" reads as though payment is merely pending, when really the
    // work itself hasn't cleared review. Jobs with no order at all have no
    // approval step to wait on, so they stay in this state indefinitely.
    const orderApproved = job.order_status === 'ready_for_invoice' || job.order_status === 'complete';
    if (orderApproved) {
        return { key: 'unpaid', label: 'Earned — pending payment', color: '#a3c44c' };
    }
    return { key: 'pending_review', label: 'Pending — under review', color: '#d4a84b' };
}
